import { createComponent, createHook } from 'reakit-system';
import { css, cx } from '@emotion/css';
import type { TextHTMLProps, TextOptions } from '../Text/Text';
import { useText } from '../Text/Text';

export type HintOptions = Omit<
  TextOptions,
  'lineHeight' | 'fontSize' | 'color' | 'fontWeight'
>;
export type HintProps = HintOptions & TextHTMLProps;

export const useHint = createHook<HintOptions, TextHTMLProps>({
  compose: [useText],
  useOptions(options) {
    return {
      ...options,
      color: 'hintColor',
      fontSize: 'hintFontSize',
      lineHeight: 'hintLineHeight',
      fontWeight: 'normal',
    };
  },
  useProps(_, { className, ...props }) {
    return {
      ...props,
      className: cx(className, css({ label: 'Hint' })),
    };
  },
});

export const Hint = createComponent({
  as: 'span',
  useHook: useHint,
  memo: true,
});
